import React, { memo } from 'react';
import { Card } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';

import FormSearchFilter from './layout/loc-co-phieu/layout/formSearchFilter';
import PanelConditionSearch from './layout/loc-co-phieu/panelCondSearch';

import { ReactComponent as IconFolderAdd } from 'assets/img/icon/icFolderAdd.svg';
import { makeGetAnalFilterAct, makeGetToken } from 'lib/selector';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { formatDate, numberFormat } from 'utils';

import Loading from 'components/loading';

import * as _ from 'lodash';
import {
  analUserFilterRequest,
  analFilterRangeRequest,
  analFilterActionSuccess,
  analFilterRangeSuccess,
  analUserFilterSuccess,
} from 'containers/market/actions';
import styled from 'styled-components';
import { analDelFilterRequest } from 'containers/market/actions';
import { analDelFilterSuccess } from 'containers/market/actions';
import { setToast } from 'containers/client/actions';
import StockDetailModal from 'components/modal/stockDetail';

//#region styled
const StyledDivTable = styled.div`
  position: relative;

  table {
    position: relative;
  }

  table thead th {
    position: sticky;
    top: 0;
  }

  table thead th:first-child {
    left: 0;
    z-index: 1;
    width: 86px;
    min-width: 86px;
    box-shadow: inset -1px 0 0 ${props => props.theme === 'dark' ? '#282636' : '#666666'};
  }

  table thead th:nth-child(2) {
    left: 85px;
    z-index: 1;
    width: 62px;
    min-width: 62px;
    box-shadow: inset -1px 0 0 ${props => props.theme === 'dark' ? '#282636' : '#666666'};;
  }
  table thead th:nth-child(3) {
    left: 146px;
    z-index: 1;
    width: 50px;
    min-width: 50px;
    box-shadow: inset -1px 0 0 ${props => props.theme === 'dark' ? '#282636' : '#666666'};;
  }

  table tbody th {
    position: sticky;
    background: #181625;
    padding: 10px 8px;
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
  }
  table tbody th:first-child {
    left: 0;
    // z-index: 1;
    width: 86px;
    min-width: 86px;
    // box-shadow: inset -1px 0 0 #282636;
  }

  table tbody th:nth-child(2) {
    left: 85px;
    // z-index: 1;
    width: 62px;
    min-width: 62px;
    // box-shadow: inset -1px 0 0 #282636;
  }
  table tbody th:nth-child(3) {
    left: 146px;
    // z-index: 1;
    width: 50px;
    min-width: 50px;
    // box-shadow: inset -1px 0 0 #282636;
  }
  table.theme-light thead th {
    background: #666666;
  }

  table.theme-light.table-analysis tbody tr:nth-child(odd) th,
  table.theme-light.table-analysis tbody tr:nth-child(odd) td {
    background: #eeeeee;
  }
  table.theme-light.table-analysis tbody tr:nth-child(even) th {
    background: #CACACA;
  }
`;

//#endregion

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function TabAnalysisFilter(props) {
  const [headerFilter, setHeaderFilter] = React.useState(null);
  const [saveFilter, setSaveFilter] = React.useState(false);
  const [clearFiler, setClearFilter] = React.useState(false);
  const [condSearch, setCondSearch] = React.useState(null);
  const [symbolActive, setSymbolActive] = React.useState(null);

  const dispatch = useDispatch();
  const { token, analFilterAct, analDelFilter, analFilterActLoading, t, lang, theme } = props;

  const preAnalFilterAct = usePrevious(analFilterAct);

  React.useEffect(() => {
    dispatch(analFilterRangeRequest());
    dispatch(analUserFilterRequest(token?.user));

    return () => {
      dispatch(analFilterActionSuccess(null));
      dispatch(analFilterRangeSuccess(null));
      dispatch(analUserFilterSuccess(null));
    };
  }, []);

  React.useEffect(() => {
    if (analFilterAct && !_.isEqual(analFilterAct, preAnalFilterAct)) {
      dispatch(analUserFilterRequest(token?.user));
    }
  }, [analFilterAct]);

  React.useEffect(() => {
    if (analDelFilter) {
      handleToast(t('algo.lcp.txt-del-bl-success'), 'success');
      // setHeaderFilter(null);
      dispatch(analDelFilterSuccess(null));
      dispatch(analUserFilterRequest(token?.user));

      dispatch(analFilterActionSuccess(null));
      setClearFilter(true)
    }
  }, [analDelFilter]);

  function _handleDeleteFilter() {
    console.log(headerFilter)
    if(headerFilter?.filter){
      const params = {
        filterId: headerFilter?.filter,
        user: token.user
      };
      dispatch(analDelFilterRequest(params))
    }
  }
  
  function handleToast(msg, type = 'info') {
    // log(msg)
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
      type,
    };
    dispatch(setToast(toastMsg));
  }

  const handleOpenModal = (sym) => {
    setSymbolActive(sym);
  };

  const onClose = () => {
    setSymbolActive(null);
  }

  // log(analFilterAct, headerFilter);

  return (
    <div className="w-100 d-flex flex-column">
      <Card className="w-100" style={{ height: '300px' }}>
        <Card.Header className="d-flex p-0">
          <div
            className="analysis-sym-header mb-0 w-100"
            style={{ padding: '4px 16px', background: theme === 'dark' ? '#020210' : '#7d7d7d' }}
          >
            <FormSearchFilter setHeaderFilter={setHeaderFilter} t={t} theme={theme}/>
          </div>
        </Card.Header>
        <Card.Body className="h-100 p-0">
          <PanelConditionSearch
            headerFilter={headerFilter}
            svFilter={saveFilter}
            clearFiler={clearFiler}
            setClearFilter={setClearFilter}
            setSaveFilter={setSaveFilter}
            setCondSearch={setCondSearch}
            t={t}
            theme={theme}
          />
        </Card.Body>
      </Card>

      <Card
        className="w-100"
        style={{ marginTop: '16px', background: '#1C192C' }}
      >
        <Card.Body className="h-100 d-flex flex-column p-0">
          <div className="d-flex align-items-center py-0 pr-2 tabs-cash">
            <a className={'fz-14 mr-auto'}>
              {t('algo.lcp.txt-Result')}{' '}
              {analFilterAct && analFilterAct.items
                ? '(' + analFilterAct.items.length + ')'
                : ''}
            </a>
            <a className={'fz-14'}
            onClick={_handleDeleteFilter}
            style={{
                padding: '8px 16px',
                height: '32px',
                background: 'transparent',
                color: '#F0B90B',
                border: '1px solid #F0B90B',
                borderRadius: '3px',
                lineHeight: '16px',
                marginRight: '10px'
              }}>
              {t('algo.lcp.txt-Delete-watchlist')}
            </a>
            <a
              className={'fz-14 mx-0 d-flex align-items-center'}
              onClick={() => setSaveFilter(true)}
              style={{
                padding: '8px 16px',
                height: '32px',
                background: '#F0B90B',
                color: '#27272D',
                borderRadius: '3px',
                lineHeight: '16px',
              }}
            >
              {t('algo.lcp.txt-Save')}
            </a>
          </div>
          <PerfectScrollbar
            style={{ height: 'calc(100vh - 455px)' }}
            className="w-100"
          >
            <StyledDivTable theme={theme}>
              <table className={"table table-borderless table-analysis theme-" + theme}>
                <thead>
                  <tr>
                    <th className="text-nowrap">{t('algo.cb.txt-Trade-date')}</th>
                    <th className="text-nowrap">{t('algo.cb.txt-Exchange')}</th>
                    <th className="text-nowrap">{t('algo.cb.txt-Ticker')}</th>
                    <th className="text-nowrap text-right">{t('algo.lcp.txt-Price-change-per-week')}</th>
                    <th className="text-nowrap text-right">{t('algo.lcp.txt-Price-change-per-month')}</th>
                    <th className="text-nowrap text-left">{t('algo.lcp.txt-Industry')}</th>
                    {condSearch &&
                      condSearch.map((item) => (
                        <th className="text-nowrap text-right" key={item.itemValue}>
                          {item.itemName}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {analFilterAct &&
                    analFilterAct.items &&
                    analFilterAct.items.map((item, index) => (
                      <tr key={index}>
                        <th className="txt-content text-center">
                          {formatDate(new Date(), '/', 'dmy')}
                        </th>
                        <th className="txt-content text-center">
                          {item.EXCHANGE_CODE}
                        </th>
                        <th className="txt-content text-center">
                          <a onClick={() => handleOpenModal(item.SECURITY_CODE)}>
                            {item.SECURITY_CODE}
                          </a>
                        </th>
                        <td className={"txt-content text-right " + (item.P_CHANGE_1W > 0 ? 'i' : item.P_CHANGE_1W < 0 ? 'd' : '')}>
                          {numberFormat(item.P_CHANGE_1W, 2)}
                        </td>
                        <td className={"txt-content text-right " + (item.P_CHANGE_1M > 0 ? 'i' : item.P_CHANGE_1M < 0 ? 'd' : '')}>
                          {numberFormat(item.P_CHANGE_1M, 2)}
                        </td>
                        <td className="txt-content text-nowrap">
                          {lang === 'vi' ? item.INDUSTRY_NAME : item.INDUSTRY_NAME_EN}
                        </td>
                        {condSearch &&
                          condSearch.map((o) => (
                            <td
                              className="text-right txt-content"
                              key={o.itemValue + '_' + index}
                            >
                              {(item[o.itemValue] + '').includes('.') ? numberFormat(item[o.itemValue], 2, '0') : numberFormat(item[o.itemValue], 0, '0')}
                            </td>
                          ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </StyledDivTable>
            {analFilterActLoading && <Loading />}
            {analFilterAct &&
              analFilterAct.items &&
              !analFilterAct.items.length && (
                <p className="text-center fz-12 content-read my-2">
                  {t('txt-no-data-found')}
                </p>
              )}
          </PerfectScrollbar>
        </Card.Body>
      </Card>
      {symbolActive && (
        <StockDetailModal
          showModal={true}
          handleCloseModal={onClose}
          symbol={symbolActive}
        />
      )}
    </div>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAnalFilterAct = makeGetAnalFilterAct();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      analFilterAct: getAnalFilterAct(state),
      analFilterActLoading: state.market.analFilterActLoading,
      analDelFilter: state.market.analDelFilter,
      lang: state.client?.setting?.lang || 'vi',
      theme: state.client?.setting?.theme === 'light' ? 'light' : 'dark',
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(memo(TabAnalysisFilter))
);
